export enum HeaderSection {
  Dynamic = 'dynamic',
  NaturalDiamonds = 'natural-diamonds',
  LabGrownDiamonds = 'lab-grown-diamonds',
  Jewelry = 'jewelry',
  Gems = 'gems',
  Demo = 'demo',
}
